import PropTypes from 'prop-types'
import { Component } from 'react'

import { ImageSchema } from 'images'
import { NumberPicker, SimpleButton } from 'ui'

import ScoreSchema from '../../schemas/ScoreSchema'
import MatchScore from '../MatchScore'

import styles from './index.css'

class MatchScoreEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      localScore: props.localScore,
      visitorScore: props.visitorScore,
    }
  }

  localScoreUp = () => {
    const { localScoreMax } = this.props

    this.setState(({ localScore }) => ({
      localScore: Math.min(localScore + 1, localScoreMax),
    }))
  }

  onChangeLocalScore = (localScore) => this.setState({ localScore })

  onChangeVisitorScore = (visitorScore) => this.setState({ visitorScore })

  onSave = () => {
    const { localScore, visitorScore } = this.state

    this.props.onSave({
      localScore,
      visitorScore,
    })
  }

  visitorScoreUp = () => {
    const { visitorScoreMax } = this.props

    this.setState(({ visitorScore }) => ({
      visitorScore: Math.min(visitorScore + 1, visitorScoreMax),
    }))
  }

  render() {
    const {
      className,
      localImage,
      localName,
      localScoreMax,
      localScoreMin,
      onCancel,
      visitorImage,
      visitorName,
      visitorScoreMax,
      visitorScoreMin,
    } = this.props
    const { localScore, visitorScore } = this.state

    return (
      <div className={className}>
        <MatchScore
          className={styles.scoreWrapper}
          localImage={localImage}
          localName={localName}
          onLocalClick={this.localScoreUp}
          onVisitorClick={this.visitorScoreUp}
          scoreClassName={styles.score}
          visitorImage={visitorImage}
          visitorName={visitorName}
        >
          <NumberPicker max={localScoreMax} min={localScoreMin} onChange={this.onChangeLocalScore} value={localScore} />
          ~
          <NumberPicker
            max={visitorScoreMax}
            min={visitorScoreMin}
            onChange={this.onChangeVisitorScore}
            value={visitorScore}
          />
        </MatchScore>
        <div className={styles.buttons}>
          <SimpleButton onClick={onCancel} secondary value="Cancelar" />
          <SimpleButton onClick={this.onSave} primary value="Guardar" />
        </div>
      </div>
    )
  }
}

MatchScoreEditor.propTypes = {
  localName: PropTypes.string.isRequired,
  localScore: ScoreSchema.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  visitorName: PropTypes.string.isRequired,
  visitorScore: ScoreSchema.isRequired,

  className: PropTypes.string,
  localImage: ImageSchema,
  localScoreMax: ScoreSchema,
  localScoreMin: ScoreSchema,
  visitorImage: ImageSchema,
  visitorScoreMax: ScoreSchema,
  visitorScoreMin: ScoreSchema,
}

MatchScoreEditor.defaultProps = {
  className: '',
  localImage: null,
  localScoreMax: 60,
  localScoreMin: 0,
  visitorImage: null,
  visitorScoreMax: 60,
  visitorScoreMin: 0,
}

export default MatchScoreEditor
